import api from './api';

export const listRecent = (reviewed) =>
  api.get('/admin/client-errors', { params: reviewed !== undefined ? { reviewed } : undefined }).then(r => r.data.errors);

export const setReviewed = (id, reviewed = true) =>
  api.post(`/admin/client-errors/${id}/review`, { reviewed }).then(r => r.data);
